import { FileProcessor } from './FileProcessor';
import { appState } from './appState';
import { dom } from './dom';
import { escapeHtml } from './htmlEscape';
import { store } from './store';
export async function handleFileSelect(event) {
    const input = event.target;
    if (input.files) {
        for (const file of Array.from(input.files)) {
            const processed = await FileProcessor.processFile(file);
            appState.uploadedFiles.push(processed);
        }
        updateFilesDisplay();
    }
}
export async function handleDrop(event) {
    event.preventDefault();
    if (event.dataTransfer?.files) {
        for (const file of Array.from(event.dataTransfer.files)) {
            const processed = await FileProcessor.processFile(file);
            appState.uploadedFiles.push(processed);
        }
        updateFilesDisplay();
    }
}
export function clearAllFiles() {
    appState.uploadedFiles.length = 0;
    updateFilesDisplay();
}
export function updateFilesDisplay() {
    const badge = document.getElementById('filesTabBadge');
    const count = document.getElementById('fileCount');
    const list = document.getElementById('filesList');
    const attached = document.getElementById('attachedFiles');
    if (!badge || !count || !list || !attached) {
        return;
    }
    badge.textContent = appState.uploadedFiles.length.toString();
    count.textContent = appState.uploadedFiles.length.toString();
    list.innerHTML = '';
    if (appState.uploadedFiles.length > 0) {
        attached.classList.remove('d-none');
        dom.filesTab.classList.remove('disabled');
        appState.uploadedFiles.forEach((file, index) => {
            const item = document.createElement('div');
            item.className = 'badge bg-light text-dark border d-flex align-items-center gap-2 py-1 px-2';
            item.innerHTML = `
        <i class="bi bi-${getFileIcon(file.name)}"></i>
        <span class="small" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(file.name)}</span>
      `;
            const del = document.createElement('button');
            del.type = 'button';
            del.className = 'btn-close';
            del.style.fontSize = '0.4rem';
            del.onclick = () => {
                appState.uploadedFiles.splice(index, 1);
                updateFilesDisplay();
            };
            item.appendChild(del);
            list.appendChild(item);
        });
        renderFilesTabContent();
    }
    else {
        attached.classList.add('d-none');
        dom.filesTab.classList.add('disabled');
    }
    const isReady = appState.isModelLoaded;
    const isLoggedIn = Boolean(store.getUser());
    const hasByokKeys = store.getByokKeys().length > 0;
    const canUseApp = isLoggedIn || hasByokKeys;
    const hasText = dom.inputText.value.trim().length > 0;
    const hasFiles = appState.uploadedFiles.length > 0;
    dom.mainActionBtn.disabled = !isReady || !canUseApp || (!hasText && !hasFiles);
}
export function renderFilesTabContent() {
    dom.filesContent.innerHTML = '';
    appState.uploadedFiles.forEach(file => {
        const container = document.createElement('div');
        container.className = 'mb-3 p-3 bg-body rounded border';
        const heading = document.createElement('h6');
        heading.className = 'fw-bold small';
        heading.textContent = file.name;
        const pre = document.createElement('pre');
        pre.className = 'small mb-0';
        pre.style.whiteSpace = 'pre-wrap';
        pre.textContent = file.content;
        container.appendChild(heading);
        container.appendChild(pre);
        dom.filesContent.appendChild(container);
    });
}
export function getFileIcon(filename) {
    const ext = filename.split('.').pop()?.toLowerCase() || '';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext))
        return 'file-earmark-image';
    if (['pdf'].includes(ext))
        return 'file-earmark-pdf';
    if (['doc', 'docx'].includes(ext))
        return 'file-earmark-word';
    if (['xls', 'xlsx', 'csv'].includes(ext))
        return 'file-earmark-excel';
    return 'file-earmark-text';
}
export function getIconPath(icon) {
    const icons = {
        'file-earmark-pdf': '<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/><path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z">',
        'file-earmark-word': '<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/><path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z">',
        'file-earmark-excel': '<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/><path d="M5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z">',
        'file-earmark-text': '<path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/><path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z">',
        'file-earmark-image': '<path d="M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z">',
        'file-earmark': '<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>'
    };
    return icons[icon] || icons['file-earmark'];
}
